export const centsToDollarString = (amountInCents = 0) => (
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(centsToDollars(amountInCents))
);

const roundedDollarFormatOptions = {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

export const centsToDollarStringRounded = (amountInCents = 0) => (
  new Intl.NumberFormat('en-US', roundedDollarFormatOptions).format(centsToDollars(amountInCents))
);

export const dollarToDollarString = (amountInDollars = 0) => (
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amountInDollars)
);

export const dollarToDollarStringRounded = (amountInDollars = 0) => (
  new Intl.NumberFormat('en-US', roundedDollarFormatOptions).format(amountInDollars)
);

export const dollarToDollarStringWithoutDollarSign = (amountInDollars = 0) => (
  new Intl.NumberFormat('en-US').format(amountInDollars)
);

export const centsToDollars = (amountInCents = 0) => parseFloat((amountInCents / 100).toFixed(2));

export const centsToDollarsRounded = (amountInCents = 0) => Math.round(centsToDollars(amountInCents));

export const dollarsToCents = (amountInDollars = 0.0) => parseInt((amountInDollars * 100).toFixed(2));

export const dollarStringAsNumber = (dollarString) => parseFloat(dollarString.replace(/[$,]/g, ''));
